export const DIALOG_WIDTH = 310;

export const DIALOG_WIDTH_WIDER = 325;

export const VIEW_HEIGHT = 305;
